<div class="card-container" [style.padding]="card_padding">
  <div *ngFor="let card_item_row of card_items_list" class="card-row" [style.margin]="margin"
    [style.padding-left]="padding_left" [style.padding-top]="padding_top">
    <div *ngFor="let card_item of card_item_row" class="card-item" [style.padding]="padding" [style.border]="border">
      <h5 *ngIf="card_item.title" class="card-title">
        {{ card_item.title }}
      </h5>
      <h6 *ngIf="card_item?.sub_title" class="card-subtitle mb-2 text-muted">
        {{ card_item.sub_title }}
      </h6>
      <card-single class="card-single-host" [wid]="card_item.component">
      </card-single>
      <a *ngIf="card_item?.button" href="#" class="btn btn-primary" (click)="exec(card_item); $event.preventDefault()">
        {{ card_item.button.name }}
      </a>
    </div>
  </div>
</div>